<template>
	<div class="padding-lg"></div>
</template>

<script>
export default {
	data() {
		return {
			info: {
				agent: {},
				profile: {}
			}
		};
	},
	beforecreate: function() {},
	created: function() {
	},
	mounted: function() {},
	updated: function() {},
	methods: {}
};
</script>

<style></style>
